import { Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";

import "../NotificationZone.scss";

type Props = {
  isAnchored: boolean;
  isNotificationExpanded: boolean;
  handleExpandToggle: () => void;
  handleToggleAnchor: () => void;
};

const NotificationZoneHeader: React.FC<Props> = ({
  isAnchored,
  isNotificationExpanded,
  handleExpandToggle,
  handleToggleAnchor,
}: Props) => {
  return (
    <Stack
      id="notification-zone-header"
      direction="row"
      spacing={0}
      style={{
        height: "50px",
      }}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      {isAnchored ? (
        <PushPinIcon onClick={handleToggleAnchor} />
      ) : (
        <PushPinOutlinedIcon onClick={handleToggleAnchor} />
      )}
      <h3>Zone de notification</h3>

      {isNotificationExpanded ? (
        <ExpandLessIcon
          style={{
            justifyContent: "flex-end",
          }}
          className="expand-notification-icon"
          onClick={handleExpandToggle}
          aria-label="Afficher les notifications"
        />
      ) : (
        <ExpandMoreIcon
          className="expand-notification-icon"
          onClick={handleExpandToggle}
          style={{
            justifyContent: "flex-end !important",
            justifySelf: "flex-end",
          }}
          aria-label="Cacher les notifications"
        />
      )}
    </Stack>
  );
};
export default NotificationZoneHeader;
